<script setup lang="ts">
import { ref } from 'vue'
import { makePictureTree } from '../services/FilestackServiceMakePictureTree'

const {
  model,
  handle
} = defineProps<{
  model: string
  handle: string | null
}>()

const imageLoaded = ref(false)
const imageTree = makePictureTree({
  alt: `Product Image -${model}`,
  width: '400px',
  handle
})
</script>

<template>
  <div
    class="flex align-items-center justify-content-center "
    style="min-height: 18rem"
  >
    <transition-group name="cdn-image-fade">
      <div
        v-show="!imageLoaded"
        key="placeholderImage"
        style="max-height: 400px;"
      >
        <fa-icon
          icon="fa-solid fa-circle-notch"
          class="fa-spin fa-6x text-400"
        />
      </div>
      <picture
        v-show="imageLoaded"
        :key="`fetched-image-${handle}`"
      >
        <img
          :alt="imageTree.alt"
          class="p-4"
          :src="imageTree.img.src"
          :srcset="imageTree.img.srcset"
          style="max-height: 400px; width: 100%; object-fit: contain"
          @load="imageLoaded = true"
        >
      </picture>
    </transition-group>
  </div>
</template>
